import BaseAPI from "./BaseAPI";
import { ingredientImportRoute } from "../routes";

// Client for POST /v2/ingredient-imports (admin-only on the backend). The
// import has two server-side phases — resolve/create the Stock catalogue item
// per row, then create the Ingredient lots — wrapped in one transaction.
export default class IngredientImportAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, ingredientImportRoute, "ingredient-import");
    }

    // DryRun validates + resolves server-side and returns a preview (new vs
    // matched SKUs, lot count, per-row errors) without writing anything.
    async DryRun(payload) {
        return this._request("post", this._url(), { ...payload, dry_run: true });
    }

    // Commit writes the whole batch in one transaction. Pass a fresh
    // Idempotency-Key per commit action so a network retry can't double-import.
    async Commit(payload, idempotencyKey = null) {
        const options = idempotencyKey ? { headers: { "Idempotency-Key": idempotencyKey } } : {};
        const result = await this._request("post", this._url(), { ...payload, dry_run: false }, options);
        this._emit("commit", result.import_batch_id);
        return result;
    }

    // Undo archives and zeroes every lot created by a batch (catalogue SKUs are
    // left in place, showing zero on-hand).
    async Undo(batchId) {
        const result = await this._request("post", this._url(`/${batchId}/undo`));
        this._emit("undo", batchId);
        return result;
    }
}
